//@flow

import { useAction, useAtom } from '@reatom/react'
import {
  ShowStripePaymentRequest as StripeShowApplePayRequest,
  StripeApplePaymentAtom
} from '@bfg/atoms/payment_systems/stripe/StripePayment'
import {
  ApplePaymentAtom as BraintreeApplePaymentAtom,
  ShowApplePaymentRequest as BraintreeShowApplePayRequest
} from '@bfg/atoms/payment_systems/braintree/ApplePayment'
import {
  ApplePaymentAtom as BluesnapApplePaymentAtom,
  ShowApplePaymentRequest as BluesnapShowApplePayRequest
} from '@bfg/atoms/payment_systems/bluesnap/ApplePayment'
import * as common from '@bfg/common'
import { ShowGooglePaymentRequest as StripeShowGooglePaymentRequest} from '@bfg/atoms/payment_systems/stripe/GooglePayment'
import { ShowGooglePaymentRequest as BraintreeShowGooglePaymentRequest} from '@bfg/atoms/payment_systems/braintree/GooglePayment'
import { ShowGooglePaymentRequest as BluesnapShowGooglePaymentRequest} from '@bfg/atoms/payment_systems/bluesnap/GooglePayment'
import { ProcessCardPayment } from '@bfg/atoms/payment_systems/stripe/CardPayment'
import { WalletTypeAtom } from '@bfg/atoms/WalletType'
import { WalletType } from '@bfg/enums/WalletTypesEnum'
import { AppConfigAtom } from '@bfg/atoms/AppConfig'
import { PaymentGatewayEnum } from '@bfg/enums/PaymentGatewayEnum'

// Унифицированный триггер платежа: приоритет aPay > gPay > Card, выбор
// провайдера (Stripe/Bluesnap/Braintree) — по AppConfigAtom.gateway.
export const usePrimaryPayment = () => {
  const appState = useAtom(AppConfigAtom)
  const walletTypeState = useAtom(WalletTypeAtom)
  const stripeAppleAtom = useAtom(StripeApplePaymentAtom)
  const btAppleAtom = useAtom(BraintreeApplePaymentAtom)
  const bsAppleAtom = useAtom(BluesnapApplePaymentAtom)
  let applePayState
  if (appState.gateway.aPay === PaymentGatewayEnum.STRIPE) {
    applePayState = stripeAppleAtom
  } else if (appState.gateway.aPay === PaymentGatewayEnum.BLUESNAP) {
    applePayState = bsAppleAtom
  } else {
    applePayState = btAppleAtom
  }

  const handlePayment = useAction((paymentData, sizeExperiment) => {
    if (walletTypeState.walletType === WalletType.Wallet) {
      if (applePayState.applePayEnabled) {

        if (appState.gateway.aPay === PaymentGatewayEnum.STRIPE) {
          return StripeShowApplePayRequest()
        }
        if(appState.gateway.aPay === PaymentGatewayEnum.BLUESNAP) {
          return BluesnapShowApplePayRequest()
        }
        if(appState.gateway.aPay === PaymentGatewayEnum.BRAINTREE) {
          return BraintreeShowApplePayRequest()
        }

      } else {
        common.preventLeavingWhenClickedPay()

        if (appState.gateway.gPay === PaymentGatewayEnum.STRIPE) {
          return StripeShowGooglePaymentRequest()
        }
        if(appState.gateway.gPay === PaymentGatewayEnum.BLUESNAP) {
          return BluesnapShowGooglePaymentRequest()
        }
        if(appState.gateway.gPay === PaymentGatewayEnum.BRAINTREE) {
          return BraintreeShowGooglePaymentRequest()
        }
      }
    } else {
      return ProcessCardPayment(paymentData)
    }

  }, [applePayState, appState.paymentClickCount])
  return { handlePayment }
}